import { render, staticRenderFns } from "./RqsTable.vue?vue&type=template&id=16f813fe"
import script from "./RqsTable.vue?vue&type=script&lang=ts"
export * from "./RqsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports